module.exports = __webpack_public_path__ + "static/childcouncil_card_img2@2x-359be9c8c8312d99eec4e836d9b6b49c.jpg";